const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ImpactOfAgriculture extends Event {
    constructor(){
        super(
            Age.Age3,
            EventNames.ImpactOfAgriculture,
            "Each civilization scores culture equal to the amount of food it produces with a bonus of 4 culture if this exceeds consumption.",
            {}
        )
    }
}

module.exports = ImpactOfAgriculture;